import styled from 'styled-components';

export const StyledFeedback = styled.div`
  display: flex;
  width: 100%;
  background: ${(props) => props.theme.colors.darkSurface2};
  border-radius: 8px;
  text-align: center;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 24px;

  .feedback-message {
    margin-bottom: 16px;
  }

  @media ${(props) => props.theme.device.tablet} {
    .feedback-message {
      margin-bottom: 30px;
    }
  }
`;
